import { TrackingAction, TrackingActionCategory } from '@acp/shared';
import { addGoogleAnalyticsEvent } from './use-google-analytics';
import { addDatadogEvent } from './use-datadog';

export const addTrackingEvent = ({ category, action, context }: {
    category: TrackingActionCategory;
    action: TrackingAction;
    context?: object;
}) => {
    addGoogleAnalyticsEvent({
        options: {
            category,
            action,
        },
        eventParams: context,
    });

    addDatadogEvent({
        actionName: action,
        eventContext: {
            category,
            ...context,
        },
    });
};
